import { faker } from '@faker-js/faker';
import { Factory, trait } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.name.fullName();
  },

  label() {
    return this.name;
  },

  width() {
    return faker.datatype.number({
      min: 900,
      max: 2000,
    });
  },

  isCroppingFormat() {
    return faker.datatype.boolean();
  },

  isDownloadFormat() {
    return faker.datatype.boolean();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  source: trait({
    id() {
      return '195';
    },

    name() {
      return 'Source';
    },

    label() {
      return 'Source';
    },

    isDownloadFormat() {
      return true;
    },
  }),

  format836: trait({
    id() {
      return '836';
    },

    name() {
      return 'ipad_mp4';
    },

    label() {
      return '576p';
    },

    isDownloadFormat() {
      return true;
    },
  }),
});
